<template>
    <v-menu v-if="contextMenuVisible" v-model="contextMenuVisible" :position-x="contextMenuX" :position-y="contextMenuY" absolute offset-y :attach="attach" :close-on-content-click="false">
        <v-card tile>
            <div class="d-flex align-center justify-space-between black white--text pa-1 text-body-2">
                <span class="font-weight-bold">{{ contextInformation.reference }}</span>
                <v-btn icon dark color="red" small @click="contextMenuVisible = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-alert v-if="contextInformation.warning" dense color="warning" border="left" icon="mdi-alert" class="pa-2 ma-2">{{ contextInformation.warning }}</v-alert>
            <v-list>
                <v-list-item v-if="onSelectService && contextInformation.pickupServiceId" two-line @click="switchToAnotherScheduledService(contextInformation.pickupServiceId)">
                    <v-list-item-icon><v-icon>mdi-bus</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ contextInformation.pickupServiceName }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <span v-if="contextInformation.pickupGuide">{{ contextInformation.pickupGuide }}</span>
                            <span v-else>No tiene guía asignado</span>
                            <span v-if="contextInformation.pickupBusNumber" class="ml-2">(bus: {{ contextInformation.pickupBusNumber }})</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon><v-icon>mdi-open-in-app</v-icon></v-list-item-icon>
                </v-list-item>
                <v-list-item v-if="onSelectService && contextInformation.activityServiceId" two-line @click="switchToAnotherScheduledService(contextInformation.activityServiceId)">
                    <v-list-item-icon><v-icon>mdi-bus</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ contextInformation.activityServiceName }}</v-list-item-title>
                        <v-list-item-subtitle>
                            <span v-if="contextInformation.activityGuide">{{ contextInformation.activityGuide }}</span>
                            <span v-else>No tiene guía asignado</span>
                            <span v-if="contextInformation.activityBusNumber" class="ml-2">(bus: {{ contextInformation.activityBusNumber }})</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon><v-icon>mdi-open-in-app</v-icon></v-list-item-icon>
                </v-list-item>

                <v-menu bottom absolute offset-x max-width="240px" :close-on-content-click="false" :attach="attach">
                    <template v-slot:activator="{ on }">
                        <v-list-item v-on="on" :disabled="!contextInformation.allowChangeOccupancy">
                            <v-list-item-icon><v-icon>mdi-account-multiple-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span v-if="contextInformation.adults === 1">1 adulto</span>
                                    <span v-else>{{ contextInformation.adults }} adultos</span>

                                    <span v-if="contextInformation.children === 1">, 1 niño</span>
                                    <span v-else-if="contextInformation.children > 1">, {{ contextInformation.children }} niños</span>

                                    <span v-if="contextInformation.babies === 1">, 1 bebé</span>
                                    <span v-else-if="contextInformation.babies > 1">, {{ contextInformation.babies }} bebés</span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon v-if="contextInformation.editOccupancy">mdi-chevron-down</v-icon>
                                <v-icon v-else>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>

                    <v-card width="240px">
                        <v-list-item>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newAdults--" :disabled="contextInformation.newAdults === 0"><v-icon>mdi-minus-circle</v-icon></v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ contextInformation.newAdults }} Adultos</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newAdults++"><v-icon>mdi-plus-circle</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newChildren--" :disabled="contextInformation.newChildren === 0"><v-icon>mdi-minus-circle</v-icon></v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ contextInformation.newChildren }} Niños</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newChildren++"><v-icon>mdi-plus-circle</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newBabies--" :disabled="contextInformation.newBabies === 0"><v-icon>mdi-minus-circle</v-icon></v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ contextInformation.newBabies }} Bebés</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="contextInformation.newBabies++"><v-icon>mdi-plus-circle</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <div class="d-flex align-center justify-space-between pa-4">
                            <v-btn
                                block
                                color="primary"
                                @click="editBookingOccupancy"
                                :loading="updatingContext"
                                :disabled="
                                    contextInformation.adults === contextInformation.newAdults &&
                                    contextInformation.children === contextInformation.newChildren &&
                                    contextInformation.babies === contextInformation.newBabies
                                "
                            >
                                Guardar cambios
                            </v-btn>
                        </div>
                    </v-card>
                </v-menu>

                <v-menu bottom absolute offset-x max-width="240px" :close-on-content-click="false" :attach="attach">
                    <template v-slot:activator="{ on }">
                        <v-list-item v-on="on" :disabled="!contextInformation.allowChangeLanguage">
                            <v-list-item-icon><LanguageIcon :language="contextInformation.language" /></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ contextInformation.languageName }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>

                    <v-card width="240px">
                        <v-list-item v-for="language in languages" :key="language.id" @click="editBookingLanguage(language.id)">
                            <v-list-item-icon><LanguageIcon :language="language.id" /></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ language.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-menu>

                <v-list-item v-if="contextInformation.status === 'CONFIRMED'" @click="noShowBooking" :disabled="!contextInformation.allowNoShow">
                    <v-list-item-icon><v-icon>mdi-eye-off-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Marcar como NO SHOW</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="contextInformation.status === 'CONFIRMED'" @click="cancelBooking" :disabled="!contextInformation.allowCancel">
                    <v-list-item-icon><v-icon>mdi-trash-can-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Cancelar reserva</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="contextInformation.status === 'NOSHOW'" @click="showBooking" :disabled="!contextInformation.allowShow">
                    <v-list-item-icon><v-icon>mdi-location-enter</v-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Volver a confirmar reserva</v-list-item-title>
                        <v-list-item-subtitle>Se añadirá automáticamente a los servicios anteriores</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="onEdit" @click="viewBooking">
                    <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                    <v-list-item-title>Ver reserva</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<style scoped lang="scss"></style>

<script lang="ts">
import { BaseView } from "@/components/BaseView";
import { EventBus } from "@/components/EventBus";
import { BookingContextMenuRequest, DataClient } from "@/services/DataClient";
import { Utilities } from "@/services/Utilities";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class extends BaseView {
    contextMenuVisible = false;
    contextMenuX = 0;
    contextMenuY = 0;

    attach: any = "";

    updatingContext = false;

    contextInformation = {
        warning: "",

        // permissions
        allowChangeOccupancy: false,
        allowChangeLanguage: false,
        allowNoShow: false,
        allowShow: false,
        allowCancel: false,

        id: "",
        reference: "",
        status: "",
        agency: "",
        pickupServiceId: "",
        pickupServiceName: "",
        pickupGuide: "",
        pickupBusNumber: "",
        activityServiceId: "",
        activityServiceName: "",
        activityGuide: "",
        activityBusNumber: "",
        language: "",
        languageName: "",
        adults: 0,
        children: 0,
        babies: 0,
        newAdults: 0,
        newChildren: 0,
        newBabies: 0,
        editOccupancy: false,
    };

    resultAction: "none" | "select-service" | "edit-booking" | "change" = "none";
    date?: string;
    scheduledServiceId?: string;

    onChange?: () => void = undefined;
    onEdit?: () => void = undefined;
    onSelectService?: (id: string, date: string) => void = undefined;

    languages = [
        { id: "es", name: "Español" },
        { id: "en", name: "Inglés" },
        { id: "de", name: "Alemán" },
        { id: "fr", name: "Francés" },
        { id: "it", name: "Italiano" },
        { id: "cz", name: "Checo" },
        { id: "pt", name: "Portugués" },
        { id: "ru", name: "Ruso" },
        { id: "ro", name: "Rumano" },
        { id: "pl", name: "Polaco" },
    ];

    mounted() {
        EventBus.$on(DataClient.Dialogs.OpenBookingContextEvent, this.handleOpenEvent);
    }

    beforeDestroy() {
        EventBus.$off(DataClient.Dialogs.OpenBookingContextEvent, this.handleOpenEvent);
    }

    @Watch("contextMenuVisible")
    onContextMenuVisibleChanged(newValue: boolean) {
        if (!newValue) {
            this.reset();
            DataClient.Dialogs.bookingContext(undefined, true);
        }
    }

    reset() {
        console.log("reset");

        this.contextMenuVisible = false;
        this.onChange = undefined;
        this.onEdit = undefined;
        this.onSelectService = undefined;
    }

    async handleOpenEvent(event: BookingContextMenuRequest) {
        event.event.preventDefault();

        this.contextMenuX = event.event.clientX;
        this.contextMenuY = event.event.clientY;
        this.attach = event.attach;

        const [booking, information] = await Promise.all([DataClient.Bookings.get({ id: event.id }), DataClient.Bookings.getPickupInformation({ id: event.id })]);

        this.onChange = event.onChange;
        this.onEdit = event.onEdit;
        this.onSelectService = event.onSelectService;

        let allowModification = true;
        const isCancelled = booking.status === "CANCELLED";

        const isInvoiced = booking.invoicingSlots.some((x) => x.invoiceId !== "");

        if (booking.dayClosed) {
            this.contextInformation.warning = "Operativa cerrada";
            allowModification = false;
        } else if (isInvoiced) {
            this.contextInformation.warning = "Reserva ya facturada";
            allowModification = false;
        } else {
            this.contextInformation.warning = "";
        }

        this.contextInformation.allowChangeOccupancy = allowModification && !isCancelled;
        this.contextInformation.allowChangeLanguage = allowModification && !isCancelled;
        this.contextInformation.allowNoShow = booking.allowNoShow;
        this.contextInformation.allowShow = booking.allowNoShow;
        this.contextInformation.allowCancel = allowModification && (booking.status === "CONFIRMED" || booking.status === "NOSHOW");

        this.contextInformation.id = booking.id;
        this.contextInformation.reference = booking.reference;
        this.contextInformation.status = booking.status;

        this.date = booking.date;
        this.scheduledServiceId = "";

        if (information.pickupServiceId) {
            this.contextInformation.pickupServiceId = information.pickupServiceId;
            this.contextInformation.pickupServiceName = information.pickupServiceName;
            this.contextInformation.pickupGuide = information.pickupGuideName;
            this.contextInformation.pickupBusNumber = information.pickupBusNumber;
        } else {
            this.contextInformation.pickupServiceId = "";
            this.contextInformation.pickupServiceName = "";
            this.contextInformation.pickupGuide = "";
            this.contextInformation.pickupBusNumber = "";
        }

        if (information.activityServiceId) {
            this.contextInformation.activityServiceId = information.activityServiceId;
            this.contextInformation.activityServiceName = information.activityServiceName;
            this.contextInformation.activityGuide = information.activityGuideName;
            this.contextInformation.activityBusNumber = information.activityBusNumber;
        } else {
            this.contextInformation.activityServiceId = "";
            this.contextInformation.activityServiceName = "";
            this.contextInformation.activityGuide = "";
            this.contextInformation.activityBusNumber = "";
        }

        this.contextInformation.editOccupancy = false;

        this.contextInformation.adults = booking.adults;
        this.contextInformation.children = booking.children;
        this.contextInformation.babies = booking.babies;
        this.contextInformation.newAdults = booking.adults;
        this.contextInformation.newChildren = booking.children;
        this.contextInformation.newBabies = booking.babies;

        this.contextInformation.language = booking.language;
        this.contextInformation.languageName = this.languages.find((x) => x.id === booking.language)?.name || "Idioma desconocido";

        this.$nextTick(() => {
            this.contextMenuVisible = true;
        });
    }

    switchToAnotherScheduledService(id: string) {
        if (this.onSelectService) {
            this.onSelectService(id, this.date || "");
        }

        this.contextMenuVisible = false;
    }

    async editBookingOccupancy() {
        this.updatingContext = true;

        await this.secureExecution(async () => {
            await DataClient.Bookings.editOccupancy({
                id: this.contextInformation.id,
                adults: this.contextInformation.newAdults,
                children: this.contextInformation.newChildren,
                babies: this.contextInformation.newBabies,
            });

            if (this.onChange) {
                this.onChange();
            }
        });

        this.updatingContext = false;
        this.contextMenuVisible = false;
    }

    async editBookingLanguage(language: string) {
        this.updatingContext = true;

        await this.secureExecution(async () => {
            await DataClient.Bookings.editLanguage({
                id: this.contextInformation.id,
                language: language,
            });

            if (this.onChange) {
                this.onChange();
            }
        });

        this.updatingContext = false;
        this.contextMenuVisible = false;
    }

    async noShowBooking() {
        const yes = await DataClient.Dialogs.confirmation({
            title: "Marcar como no show",
            message: "¿Está seguro que desea marcar esta reserva como NO SHOW?",
            icon: "mdi-eye-off-outline",
            attach: this.attach,
        });

        if (yes) {
            await this.secureExecution(async () => {
                await DataClient.Bookings.noShow({
                    id: this.contextInformation.id,
                });

                if (this.onChange) {
                    this.onChange();
                }
            });

            this.contextMenuVisible = false;
        }
    }

    async showBooking() {
        await this.secureExecution(async () => {
            await DataClient.Bookings.show({
                id: this.contextInformation.id,
            });

            if (this.onChange) {
                this.onChange();
            }
        });

        this.contextMenuVisible = false;
    }

    async viewBooking() {
        if (this.onEdit) {
            this.onEdit();
        }

        this.contextMenuVisible = false;
    }

    async cancelBooking() {
        const yes = await DataClient.Dialogs.confirmation({
            title: "Cancelar reserva",
            message: "¿Está seguro de que desea cancelar la reserva?",
            icon: "mdi-cancel",
            attach: this.attach,
        });

        if (yes) {
            await this.secureExecution(async () => {
                await DataClient.Bookings.cancel({
                    id: this.contextInformation.id,
                });

                if (this.onChange) {
                    this.onChange();
                }
            });

            this.contextMenuVisible = false;
        }
    }
}
</script>
